export default __webpack_public_path__ + "0188899cd3ec92cdcaa4c97ca0c75247.ttf";